import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaScanPayPage } from './plaza-scan-pay';

@NgModule({
  declarations: [
    PlazaScanPayPage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaScanPayPage),
    TranslateModule.forChild()
  ],
})
export class PlazaScanPayPageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-scan-pay/plaza-scan-pay.module.ts